import React from 'react'
import { DetailedPaper } from '@cpsy-rmap-project/web-core/repositories'
import { useLocation, useHistory } from 'react-router-dom'

interface State {
  open: boolean
  paperId: string
}

interface Handle {
  handlePaperDetailsModalOpen: (paper: Pick<DetailedPaper, 'id'> | undefined) => void
  handlePaperDetailsModalClose: () => void
}

const dialogInitState: State = {
  open: false,
  paperId: ''
}

const handleInitState: Handle = {
  handlePaperDetailsModalOpen: () => {},
  handlePaperDetailsModalClose: () => {}
}

const PaperDetailsModalContext = React.createContext<State & Handle>({
  ...dialogInitState,
  ...handleInitState
})

export const PaperDetailsModalProvider: React.FC = ({ children }) => {
  /**
   * Router系設定
   */
  const history = useHistory()
  const location = useLocation()
  const query = new URLSearchParams(location.search)
  const QUERY_STRING_KEY = 'id'
  const queryStringsPaperId = query.get(QUERY_STRING_KEY)

  // URLクエリを追加する(?id=***を付与する)
  const addParams = React.useCallback(
    (id: string) => {
      const nextquery = new URLSearchParams(location.search)
      nextquery.set(QUERY_STRING_KEY, id)
      history.push(`${location.pathname}?${nextquery.toString()}`)
    },
    [history, location]
  )

  // URLクエリを除外する(?id=***を消す)
  const removeParams = React.useCallback(() => {
    const nextquery = new URLSearchParams(location.search)
    nextquery.delete(QUERY_STRING_KEY)
    history.push(`${location.pathname}?${nextquery.toString()}`)
  }, [history, location])

  // URLから移動してきた場合、IDがあればモーダルをオープンする
  React.useEffect(() => {
    if (queryStringsPaperId) {
      setPaperId(queryStringsPaperId)
      setOpen(true)
    } else {
      setPaperId('')
      setOpen(false)
    }
  }, [queryStringsPaperId])

  //

  // Modal State
  const [open, setOpen] = React.useState(dialogInitState.open)
  const [paperId, setPaperId] = React.useState(dialogInitState.paperId)

  const handlePaperDetailsModalOpen: Handle['handlePaperDetailsModalOpen'] = _paper => {
    if (_paper) {
      addParams(_paper.id)
    }
  }

  const handlePaperDetailsModalClose: Handle['handlePaperDetailsModalClose'] = () => {
    removeParams()
  }

  return (
    <PaperDetailsModalContext.Provider
      value={{
        open,
        paperId,
        handlePaperDetailsModalOpen,
        handlePaperDetailsModalClose
      }}
    >
      {children}
    </PaperDetailsModalContext.Provider>
  )
}

export const usePaperDetailsModal = () => React.useContext(PaperDetailsModalContext)
